import HttpHelpers from '../helpers';

const AddOnsApiEndpoints = {
  createAddOn: (listingId, data) => {
    return HttpHelpers.authenticatedAxios
      .post(`/host/listing/${listingId}/addon`, data)
      .then((response) => response.data);
  },

  deleteAddOn: (listingId, addOnId) => {
    return HttpHelpers.authenticatedAxios
      .delete(`/host/listing/${listingId}/addons/${addOnId}`)
      .then((response) => response.data);
  },
};

export default AddOnsApiEndpoints;
